import useCloseOnOutsideClick from "./useCloseOnOutsideClick";
import TableActionToolbar from './TableActionToolbar';
import { useFigurePanelId } from './FigurePanelIdProvider';
import G from './Getters';
import ContextMenuItem from './ContextMenuItem';
import { useState, useRef, useEffect } from 'react';
import { useStore } from 'react-redux';

const haltEvent = e => {
  e.stopPropagation();
  e.preventDefault();
}

export default function ContextMenu({
  closeOnOutsideClick, 
  closeOnEscape=true,
  y,
  x,
  onClose,
  selectedFigureItems, 
  setSelectedCells,
  items,
  onEvent,
  treeLevel=0,
  openPath,
  setOpenPath,
  transform,
  theme="light",
  submenuDirection="right",
  globalStyle={},
  roundCorners,
}){

  const store = useStore();
  const state = store.getState();
  
  const figurePanelId = useFigurePanelId();

  /*
  if(!figurePanelId){
    throw Error("MAG Context menu was not passed `figurePanelId`");
  }
  */

  function keyPressListener(e){
   
    console.log(e.key)
    if( closeOnEscape && (e.key === 'Escape') ){
      onClose?.()
    }

  }

  useEffect(() => {
    window.addEventListener('keyup',keyPressListener)
    return () => window.removeEventListener('keyup',keyPressListener)
  })

  const [ internalOpenPath, setInternalOpenPath ] = useState([]);

  
  let content;
  if( selectedFigureItems?.cells?.length ){

    let { figurePanelType } = G.getFigurePanel(state, {figurePanelId});
    let isMicroscopyPanel = (figurePanelType === "microscopy");

    const itemOrder = ['merge','line','addRowAbove','addRowBelow','addColumnLeft','addColumnRight','line','deleteRow','deleteColumn','line','split'];

    let singleCellSelected = selectedFigureItems.cells.length === 1;


    if( singleCellSelected && isMicroscopyPanel ){
      let cellValue = G.getCellsValue(state,{cells:selectedFigureItems.cells||[], figurePanelId})[0]
      if( !cellValue?.regions?.main ){
        itemOrder.splice(0,0,'insertImage','line',);
      }else{
        itemOrder.splice(0,0,'editChannels','line',);
      }
    }

    content = (
      <>
        <TableActionToolbar 
          {...{
            figurePanelId,
              selectedFigureItems,
              setSelectedCells,
          }}
          location={"context-menu"}
          onItemClicked={onClose}
          shouldSplitText={false}
          itemOrder={itemOrder}
        />
      </>
    )

  }else{
    content = (<table style={{
      zIndex:'inherit',
      //background:'orange',
      width:'100%',

    }}>{items?.map(item => {

      return <ContextMenuItem {...{
        roundCorners,
        globalStyle,
        //style,
        onClose,
        onEvent,
        item,
        treeLevel,
        openPath:(openPath||internalOpenPath),
        setOpenPath:(setOpenPath||setInternalOpenPath),
        submenuDirection
      }}/>
    })}
    </table>)
  }

 
  let position = [x,y].every(z => z!==null)?'fixed':null;

  const menuRef = useRef();

 
  useCloseOnOutsideClick(menuRef,closeOnOutsideClick && onClose);


  return (
    <div ref={menuRef} id={"sg-context-menu"} class="sg-context-menu"

      onMouseDown={e => e.stopPropagation()}
      onMouseUp={e => e.stopPropagation()}
      onMouseLeave={(e) => {
        console.log(e);
        //setOpenPath?.([]);
      }}
      onClick={e => {
        e.stopPropagation()
      }}

      style={{
        position,//:'fixed',
        top:y, 
        left:x, 
        fontSize:12,

        //minWidth:100,
        background:'#ececec', 
        
        //zIndex:100000,
        border:'1px solid #ccc', 

        //borderRadius:5,

        boxShadow:'0 2px 4px rgba(0 0 0 / 30%), 0 8px 16px rgba(0 0 0 / 30%)',
        boxSizing:'border-box',
        ...globalStyle,
        ///...style,
        transform,
        ...(roundCorners ? { borderRadius:10 } : {}),
        //:'translate(-50%, calc(-100% - 5px) )',

      }}>
      {false && <div> {JSON.stringify(internalOpenPath)} </div>}
      {content}

      


    </div>
  )
}
